export default {
  // storage const key
  TOKEN: 'token',
  AUTO_LOGIN: 'autologin',
  FACTORY: 'factory',
  // URLs
  URL_HOME: '/#/factories',
  URL_LOGIN: '/login.html',
  // ROUTER_NAME
  ROUTER_NAME_HOME: '主页',

  ROUTER_NAME_FRAME: '框架',
  ROUTER_NAME_FACTORIES: '选择工厂',
  ROUTER_NAME_PRODUCTIVITY: '生产效率',
  ROUTER_NAME_SCORE: '效率评分',
  ROUTER_NAME_RUNNING_HOURS: '平均工作时间',
  ROUTER_NAME_FLAW: '瑕疵总个数',

  ROUTER_NAME_MACHINE: '机器管理',
  ROUTER_NAME_OVERVIEW: '机器总览',
  ROUTER_NAME_MACHINE_DETAILS: '机器详情',

  ROUTER_NAME_MANAGE: '后台管理',
  ROUTER_NAME_MANAGE_FACTORY: '工厂管理',
  ROUTER_NAME_MANAGE_USER: '用户管理',

  ROUTER_NAME_PASSWORD: '修改密码',

  ROUTER_NAME_404: '404',

  LIMIT_MAX: 99999,
}
